(function() {
  // Hover-capable devices use the CSS-driven hover reveal — no JS needed.
  if (window.matchMedia('(hover: hover)').matches) return;

  var REVEALED = 'is-revealed';
  var CARD_SELECTOR = '.shop-page__card';
  var BUTTON_SELECTOR = '.shop-page__add-btn';

  function clearRevealedExcept(card) {
    document.querySelectorAll(CARD_SELECTOR + '.' + REVEALED).forEach(function(c) {
      if (c !== card) c.classList.remove(REVEALED);
    });
  }

  document.addEventListener('click', function(e) {
    // Click on the add/select button is native; let it through.
    if (e.target.closest(BUTTON_SELECTOR)) {
      return;
    }

    var card = e.target.closest(CARD_SELECTOR);

    if (!card) {
      clearRevealedExcept(null);
      return;
    }

    // Skip placeholder cards — they have no real product to reveal.
    if (card.classList.contains('shop-page__card--placeholder')) {
      return;
    }

    if (!card.classList.contains(REVEALED)) {
      // First tap: reveal this card; suppress the inner link's navigation.
      e.preventDefault();
      clearRevealedExcept(card);
      card.classList.add(REVEALED);
      return;
    }
    // Second tap: card is already revealed — let the inner <a class="shop-page__card-link"> fire normally.
  }, true);

  document.addEventListener('scroll', function() {
    clearRevealedExcept(null);
  }, { passive: true });
})();
